/**

 Registriert SignalEvents:
 =========================

 markermouseover (map:ym.map.CMap, event:Object)
 markermouseout  (map:ym.map.CMap, event:Object)
 markerclick     (map:ym.map.CMap, geoPosition:ym.geo.CGeoPoint, pixelPosition:ym.common.CPixel)
 markermousedown (map:ym.map.CMap, geoPosition:ym.geo.CGeoPoint, pixelPosition:ym.common.CPixel)
 markermouseup   (map:ym.map.CMap, event:Object)

 */
function CMarkerSignals(/** object */ markerOptions, /** ym.event.CEventEmitter */ signalsObject) {
	this.signalsObject = signalsObject;

	var self = this,
		events = ['onmouseover', 'onmouseout', 'onclick', 'onmousedown', 'onmouseup'];

	this.marker = new ym.map.CMarker(markerOptions);

	function _addListener(eventName) {
		return function () {
			self['_' + eventName].apply(self, Array.prototype.slice.call(arguments, 0));
		};
	}

	for (var i = 0, l = events.length; i < l; i++) {
		this.marker.addListener(events[i], _addListener(events[i]));
	}
}

CMarkerSignals.prototype = {
	constructor: CMarkerSignals,

	_onmouseover: function (event) {
		this.signalsObject.emit('markermouseover', this.marker, event);
	},
	_onmouseout: function (event) {
		this.signalsObject.emit('markermouseout', this.marker, event);
	},
	_onclick: function (event) {
		this.signalsObject.emit('markerclick', this.marker, event);
	},
	_onmousedown: function (event) {
		this.signalsObject.emit('markermousedown', this.marker, event);
	},
	_onmouseup: function (event) {
		this.signalsObject.emit('markermouseup', this.marker, event);
	}
};
